var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.color,"href":_vm.link,"target":_vm.target},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.title)),_c('v-icon',{attrs:{"small":_vm.small,"large":_vm.large}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }